export default __webpack_public_path__ + "static/media/edio-marreiro.a8c18eef.jpg";